import { useThree } from '@react-three/fiber';
import { useEffect, useState } from 'react';

import { cn } from '@/package';
import Loader from '@/package/kiska/src/component/UI/asset/icon/loader.svg?raw';

type LoaderData = {
  visible: boolean;
  x: number;
  y: number;
  width: number;
  height: number;
};

const INIT_LOADER_DATA: LoaderData = {
  visible: false,
  x: 0,
  y: 0,
  width: 0,
  height: 0,
};

const useAiAssistLoader = () => {
  const { gl } = useThree();
  const [aiAssistLoaderData, setAiAssistLoaderData] =
    useState(INIT_LOADER_DATA);

  const createAiAssistLoader = () => {
    const { x, y, height, width } = aiAssistLoaderData;
    const loaderWrapperEl = document.createElement('div');

    loaderWrapperEl.style.top = `${y}px`;
    loaderWrapperEl.style.left = `${x}px`;
    loaderWrapperEl.style.height = `${height}px`;
    loaderWrapperEl.style.width = `${width}px`;
    loaderWrapperEl.id = 'ai-assist-loader';
    loaderWrapperEl.className = cn(
      'fixed flex items-center justify-center text-white',
    );
    loaderWrapperEl.innerHTML = `<div class="${cn('animate-spin')}">${Loader}</div>`;

    gl.domElement.parentElement?.append(loaderWrapperEl);
  };

  const removeAiAssistLoader = () => {
    gl.domElement.parentElement?.querySelector('#ai-assist-loader')?.remove();
  };

  const setAutoHideTimeout = () => {
    setTimeout(hide, 1000 * 10);
  };

  const hide = () => {
    setAiAssistLoaderData(INIT_LOADER_DATA);
  };

  const show = ({ x, y, width, height }: Omit<LoaderData, 'visible'>) => {
    setAiAssistLoaderData({
      visible: true,
      x,
      y,
      width,
      height,
    });
  };

  useEffect(() => {
    if (!aiAssistLoaderData.visible) {
      removeAiAssistLoader();
    } else {
      createAiAssistLoader();
      setAutoHideTimeout();
    }

    return () => {
      removeAiAssistLoader();
    };
  }, [aiAssistLoaderData]);

  return {
    hide,
    show,
  };
};

export default useAiAssistLoader;
